/* eslint-disable react/prop-types */
import { useSelector } from "react-redux";
import { Clock } from "lucide-react";

const getInitials = (name) => {
  if (!name) return "U";
  const parts = name.trim().split(/\s+/);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }
  return name.slice(0, 2).toUpperCase();
};

const User = ({
  id,
  name,
  role,
  designation,
  onClick,
  time,
  show,
  status,
  showStatus,
}) => {
  const selectedUser = useSelector((state) => state.selectedUser);
  const isSelected = selectedUser?.id == id && show;
  const isClockedIn = Boolean(time && showStatus);

  const displayRole =
    (typeof designation === "string" && designation.trim()) ||
    (typeof role === "string" && role.trim()) ||
    (Array.isArray(role) && role[0]) ||
    "Staff";

  return (
    <div
      onClick={() => onClick && onClick()}
      className={`
        w-[160px] sm:w-[172px] h-[116px] shrink-0 p-2.5 rounded-2xl
        flex flex-col justify-between items-center text-center
        cursor-pointer select-none backdrop-blur-sm
        transition-all duration-200 active:scale-[0.97]
        ${
          isSelected
            ? "bg-amber-400/15 border-2 border-amber-400 shadow-[0_0_22px_rgba(245,158,11,0.35)] scale-[1.02]"
            : "bg-color2/60 border border-white/10 hover:border-amber-400/50 hover:bg-color2/90 hover:shadow-[0_4px_16px_rgba(0,0,0,0.35)] hover:scale-[1.01]"
        }
      `}
    >
      {/* Top: Avatar & Name */}
      <div className="flex flex-col items-center gap-1.5 w-full">
        <div className="relative">
          <div
            className={`
              w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold transition-colors
              ${
                isSelected
                  ? "bg-amber-400 text-slate-950 shadow-[0_0_12px_rgba(245,158,11,0.6)]"
                  : "bg-slate-700/80 text-slate-200 border border-white/15"
              }
            `}
          >
            <span>{getInitials(name)}</span>
          </div>

          {/* Status Dot */}
          <span
            className={`
              absolute -bottom-0.5 -right-0.5 w-2.5 h-2.5 rounded-full border-2 border-color1
              ${
                isClockedIn
                  ? "bg-emerald-400 shadow-[0_0_6px_rgba(52,211,153,0.9)]"
                  : "bg-slate-500"
              }
            `}
          />
        </div>

        <span
          className={`
            text-xs sm:text-sm font-bold truncate max-w-[145px] leading-tight
            ${isSelected ? "text-amber-300" : "text-white"}
          `}
        >
          {name}
        </span>
      </div>

      {/* Middle: Role Badge */}
      <span
        className={`
          text-[10px] font-semibold uppercase tracking-wider px-2 py-0.5 rounded-full leading-tight truncate max-w-[130px]
          ${
            isSelected
              ? "bg-amber-400/20 text-amber-300 border border-amber-400/40"
              : "bg-white/5 text-slate-300 border border-white/10"
          }
        `}
      >
        {displayRole}
      </span>

      {/* Bottom: Status / Clock Time */}
      <div
        className={`
          flex items-center justify-center gap-1.5 text-[11px] font-medium leading-none
          ${
            isSelected
              ? "text-amber-300/90"
              : isClockedIn
              ? "text-emerald-400"
              : "text-slate-400"
          }
        `}
      >
        <Clock className="w-3 h-3 shrink-0" />
        <span className="truncate max-w-[120px]">
          {isClockedIn ? time : status || "Clock Out"}
        </span>
      </div>
    </div>
  );
};

export default User;